import { type ReactNode } from 'react';
import { Tooltip } from '../Tooltip';

export function TruncatedCell({
  value,
  children,
  className = '',
}: {
  value: string | null | undefined;
  children?: ReactNode;
  className?: string;
}) {
  const text = value?.trim() || '—';
  const content = children ?? text;
  if (text === '—') {
    return <span className={className}>{content}</span>;
  }
  return (
    <Tooltip label={text}>
      <span className={`block min-w-0 max-w-full truncate ${className}`}>{content}</span>
    </Tooltip>
  );
}
